// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2yUCa","resendInfoText":"OnGoingPaymentBox_resendInfoText__4n17A"};